const service_gateway_url = "https://imis.uz";
export const environment = {
  production: true,
  frontendUrl: 'https://queue.imis.uz',
  clinicUIUrl: 'https://imis.uz',
  identityUrl: `https://auth.imis.uz`,
  /**Services */
  personUrl: `${service_gateway_url}/person-service`,
  commonUrl: `${service_gateway_url}/common-service`,
  clinicsUrl: `${service_gateway_url}/clinic-service`,
  reportUrl: `${service_gateway_url}/report-service`,
  doctorUrl: `${service_gateway_url}/doctor-service`,
  storageUrl: `${service_gateway_url}/storage-service`,
  notificationUrl: `${service_gateway_url}/notification-service`,
  queueUrl: `${service_gateway_url}/queue-service`,
};
